import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="flash"
export default class extends Controller {
  static targets = [];

  close() {
    this.element.classList.add("leaving");
    this.element.classList.remove("active");

    this.element.addEventListener(
      "transitionend",
      () => {
        this.element.remove();
      },
      { once: true },
    ); // only once to avoid leaks
  }

  connect() {
    // Bind handler so 'this' refers to the controller instance
    this.handleBeforeRenderBound = this.handleBeforeRender.bind(this);

    // Animate in
    requestAnimationFrame(() => {
      this.element.classList.add("active");
    });

    // Auto-dismiss after 5 seconds
    this.timeout = setTimeout(() => this.close(), 5000);

    // Listen for Turbo morph
    document.addEventListener("turbo:before-render", this.handleBeforeRenderBound);
  }

  disconnect() {
    clearTimeout(this.timeout);
    document.removeEventListener("turbo:before-render", this.handleBeforeRenderBound);
  }

  handleBeforeRender() {
    this.element.remove();
  }
}
